import { Action } from '@ngrx/store';

import { EditableItem } from '®shared/reading-list/models';

export enum ShareSheetActionTypes {
  SHOW_SHARE_SHEET_MODAL = '[Share sheet] show modal',
  HIDE_SHARE_SHEET_MODAL = '[Share sheet] hide modal',
}

export interface ItemAndResourceImage {
  item: EditableItem;
  resourceImage: string;
}

export class ShowShareSheetModalAction implements Action {
  readonly type = ShareSheetActionTypes.SHOW_SHARE_SHEET_MODAL;

  constructor(public payload: ItemAndResourceImage) {}
}

export class HideShareSheetModalAction implements Action {
  readonly type = ShareSheetActionTypes.HIDE_SHARE_SHEET_MODAL;
}

export type ShareSheetActions =
  | ShowShareSheetModalAction
  | HideShareSheetModalAction;
